var _defs, _g, _defs2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 109 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clip0)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.5 0L3.7 56.5h16.6L57 0H40.5zM54.1 38.1L.5 120h32.8L87 38.1H54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDCFF4",
    d: "M94.4 26L55.8 85h14l38.7-59H94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF1FF",
    d: "M51.3 25.4h10c1.1 0 2.2.8 2.5 2l18 73.1H30.6l18-73c.4-1.3 1.4-2 2.7-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E3FF",
    d: "M61.3 100.5h20.5l-18-73c-.3-1.3-1.4-2-2.6-2h-4.3l4.4 75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D7DA3",
    d: "M47 34.6l1.7-7.2c.3-1.2 1.4-2 2.6-2h10c1.2 0 2.3.8 2.5 2l1.8 7.2H46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B6C9B",
    d: "M63.8 27.4l1.8 7.2h-8.2l-.5-9.2h4.3c1.2 0 2.3.8 2.6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB4ED",
    d: "M70.7 55.6h-29l2.2-8.9h24.7l2.1 8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7292CC",
    d: "M70.7 55.6h-12l-.5-8.9h10.4l2.1 8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB4ED",
    d: "M78 85.1H34.5l2.1-8.8h39.2L78 85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7292CC",
    d: "M78 85.1H60.4l-.5-8.8h16L78 85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E3FF",
    d: "M82.2 9l-8.6 13.2h7.8L90 9.1h-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF1FF",
    d: "M86.6 32.9l-7.8 12h8.3l7.7-12h-8.2zM17.9 73.6L4.6 94h8.1L26 73.6h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB4ED",
    d: "M88 107.2H24.4a1 1 0 01-1-1v-4.1c0-1.1 1-2 2-2H87c1.1 0 2 1 2 2v4.1c0 .6-.4 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M78.2 100.5h3.6l-18-73c-.2-1-.9-1.7-1.7-2l16.1 75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82A4E0",
    d: "M86.4 100.1H64.6c1.4 0 2.5 1.1 2.5 2.5v4.6h20.6c.7 0 1.2-.6 1.2-1.3v-3.3c0-1.4-1.1-2.5-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92B6EA",
    d: "M86.4 100.1H83c1.4 0 2.6 1.1 2.6 2.5v4.6h2c.8 0 1.3-.6 1.3-1.3v-3.3c0-1.4-1.1-2.5-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.7 50.7c1 .1 2-.6 2.1-1.6l.5-3c.2-1-.4-2-1.4-2.2-1-.2-2 .4-2.2 1.5v.2l-.5 3c-.2 1 .5 2 1.5 2zM44.5 79c1 .1 2-.6 2.1-1.5l3-19.2c0-1-.7-1.9-1.7-2-1 0-1.8.6-2 1.5l-3 19.1c0 1 .6 2 1.6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E3FF",
    d: "M101.6 72.7H100a.3.3 0 01-.3-.3v-1.6c0-.2-.1-.3-.3-.3h-1.1c-.2 0-.4.1-.4.3v1.6c0 .2-.1.3-.3.3H96c-.2 0-.3.2-.3.4v1c0 .3.1.4.3.4h1.6c.2 0 .3.2.3.3v1.6c0 .2.2.4.4.4h1c.3 0 .4-.2.4-.4v-1.6l.3-.3h1.6c.2 0 .4-.1.4-.3V73c0-.2-.2-.3-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDFF",
    d: "M21 61.6h-1.1l-.2-.2v-1c0-.2-.1-.3-.3-.3h-.7l-.2.2v1c0 .2 0 .3-.2.3h-1c-.2 0-.3 0-.3.2v.7c0 .1.1.2.3.2h1s.2.1.2.3v1s0 .2.2.2h.7c.2 0 .3 0 .3-.2v-1c0-.2 0-.3.2-.3h1c.1 0 .2 0 .2-.2v-.7c0-.2 0-.2-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CAFF",
    d: "M28.4 46H27a.3.3 0 01-.3-.3v-1.4c0-.1-.1-.3-.3-.3h-1c-.1 0-.3.1-.3.3v1.4c0 .1 0 .3-.3.3h-1.3c-.2 0-.3 0-.3.3v1s0 .2.3.2h1.3c.2 0 .3.1.3.3v1.4c0 .1.1.3.3.3h1c.2 0 .3-.1.3-.3v-1.4c0-.1.1-.3.3-.3h1.4c.1 0 .3-.1.3-.3v-1l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E3FF",
    d: "M14.6 102.9h-1c-.1 0-.2 0-.2-.2v-1c0-.1-.1-.3-.3-.3h-.7c-.1 0-.2.1-.2.3v1s0 .2-.2.2h-1c-.2 0-.3 0-.3.2v.7c0 .2.1.3.2.3h1c.2 0 .3 0 .3.2v1c0 .1 0 .2.2.2h.7c.1 0 .3 0 .3-.2v-1c0-.1 0-.2.2-.2h1c.1 0 .2-.1.2-.3v-.7l-.2-.2zM66.4 8.5h-1c-.2 0-.3-.1-.3-.2v-1c0-.2 0-.3-.2-.3h-.7c-.1 0-.2 0-.2.2v1c0 .2-.1.3-.3.3h-1s-.2 0-.2.2v.7c0 .1 0 .2.2.2h1c.1 0 .3.1.3.3v1s0 .2.2.2h.7c.1 0 .2 0 .2-.2v-1c0-.2.1-.3.2-.3h1c.2 0 .3 0 .3-.2v-.7l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDCFF4",
    d: "M96.5 17.7h-1c-.1 0-.2 0-.2-.2v-1c0-.1-.1-.2-.3-.2h-.7c-.1 0-.2 0-.2.2v1c0 .1 0 .2-.2.2h-1c-.1 0-.2.1-.2.3v.7c0 .1 0 .2.2.2h1c.1 0 .2 0 .2.2v1c0 .2.1.3.2.3h.8s.2-.1.2-.3v-1s0-.2.2-.2h1c.1 0 .3 0 .3-.2V18c0-.2-.2-.3-.3-.3z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h107.9v120H0z",
    transform: "translate(.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a7e2f661dba6a780b47f5a9852dd7245.svg";
export { ForwardRef as ReactComponent };